import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styles from './LoadingScreen.module.scss';

interface IProps {
  message?: string;
}

const LoadingScreen = ({ message = 'Loading...' }: IProps) => {
  return (
    <div className={styles['backdrop']}>
      <div className={styles['container']}>
        <CircularProgress className={styles['circular-progress']} />
        <span className={styles['info']}>{message}</span>
      </div>
    </div>
  );
};

export default LoadingScreen;
